// 根组件：按认证阶段切换 初始化/登录/改密/主应用。
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { AppProvider, useApp } from "../app-context";
import { DesignSystemProvider } from "../design/DesignSystemProvider";
import { ChangePasswordView, LoginView, SetupView } from "./AuthViews";
import { AppShell } from "./AppShell";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

function PhaseGate() {
  const { phase, refreshAuth } = useApp();
  const { t } = useTranslation();

  useEffect(() => {
    void refreshAuth();
  }, [refreshAuth]);

  if (phase === "loading") {
    return (
      <div className="dashboard-loading" role="status">
        <Spin />
        <span>{t("common.loading")}</span>
      </div>
    );
  }
  if (phase === "setup") return <SetupView />;
  if (phase === "login") return <LoginView />;
  if (phase === "change-password") return <ChangePasswordView />;
  return <AppShell />;
}

export function App() {
  return (
    <DesignSystemProvider>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <PhaseGate />
        </AppProvider>
      </QueryClientProvider>
    </DesignSystemProvider>
  );
}
